export const JG_RADIO_CUE_STORAGE_KEY = 'jg:radioCue:v1';
export const JG_RADIO_CUE_EVENT = 'jg-radio-cue';

const cleanTrackId = (value) =>
  String(value || '')
    .trim()
    .slice(0, 120);

export const normalizeJGRadioCue = (cue = {}) => {
  const trackId = cleanTrackId(cue.trackId || cue.id);
  if (!trackId) return null;
  return {
    trackId,
    source: String(cue.source || 'manual').trim().slice(0, 80),
  };
};

const getSessionStorage = () => {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage || null;
  } catch {
    return null;
  }
};

export const setJGRadioCue = (cue) => {
  const normalized = normalizeJGRadioCue(cue);
  if (!normalized) return null;
  const storage = getSessionStorage();
  if (storage) {
    try {
      storage.setItem(JG_RADIO_CUE_STORAGE_KEY, JSON.stringify(normalized));
    } catch {
      // Cue persistence is optional; event dispatch can still work.
    }
  }
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    try {
      window.dispatchEvent(new CustomEvent(JG_RADIO_CUE_EVENT, { detail: normalized }));
    } catch {
      // Older test/browser shims can reject CustomEvent construction.
    }
  }
  return normalized;
};

export const readJGRadioCue = () => {
  const storage = getSessionStorage();
  if (!storage) return null;
  try {
    return normalizeJGRadioCue(JSON.parse(storage.getItem(JG_RADIO_CUE_STORAGE_KEY)));
  } catch {
    return null;
  }
};

export const clearJGRadioCue = () => {
  const storage = getSessionStorage();
  if (!storage) return;
  try {
    storage.removeItem(JG_RADIO_CUE_STORAGE_KEY);
  } catch {
    // Optional cleanup.
  }
};
